import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

export function CalendarHeader() {
  const { t } = useTranslation();

  const weekDays = [
    'mondayShort',
    'tuesdayShort',
    'wednesdayShort',
    'thursdayShort',
    'fridayShort',
    'saturdayShort',
    'sundayShort',
  ];
  return (
    <div
      className={cn(
        'grid grid-cols-7 gap-3 place-items-center',
        'text-neutrals-N700 font-semibold text-xs py-1 px-2',
      )}>
      {weekDays.map((key) => (
        <div key={key}>{t(`general.date.days.${key}`)}</div>
      ))}
    </div>
  );
}
